/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useState } from 'react';
import { Box, CircularProgress, TextField, Select, MenuItem, IconButton, Link } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import { useFetchEventTypes } from '../../../actions/areas/admin/fetchHooks/fetchAudit';
import { lowerFirstLetter } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';
import KeyboardDateSelector from '../../common/KeyboardDateTimeSelectors/KeyboardDateSelector';
import { isDateFromBeforeDateTo, isValidDate } from '../../../utils/dates';

const numberOfChars = 24;
const defaultState = {
  selectedEventTypes: [],
  filterDateFrom: globals.now.subtract(1, 'd'),
  filterDateTo: globals.now,
  pasKey: '',
  pasKeyErrorMessage: null,
};

export default function AuditSearchFilters({ onSubmit, events, isTableDataLoading }) {
  const [state, setState] = useState({
    selectedEventTypes: [],
    filterDateFrom: globals.now.subtract(1, 'd'),
    filterDateTo: globals.now,
    pasKey: '',
    pasKeyErrorMessage: null,
  });

  const { data: eventTypeOptions } = useFetchEventTypes(false);

  const locale = events.locale;
  const eventTypeLocale = events.eventTypeLocale;

  const handleClear = () => {
    setState(defaultState);
    onSubmit(defaultState);
  };

  const handlePasKeyChange = () => {
    let errorMessage = null;
    if (state.pasKey.length !== 0 && (state.pasKey.length > numberOfChars || state.pasKey.length < numberOfChars)) {
      errorMessage = locale.getMsg('validationPasKey');
    } else {
      errorMessage = null;
      onSubmit(state);
    }

    setState({ ...state, pasKeyErrorMessage: errorMessage });
  };

  // eslint-disable-next-line no-unused-vars
  let formattedDescription;
  const generateDescription = descriptionKey => {
    // eslint-disable-next-line no-return-assign
    return (formattedDescription = eventTypeLocale.getMsg(lowerFirstLetter(descriptionKey)));
  };

  const areDatesValid =
    isValidDate(state.filterDateFrom, true) &&
    isValidDate(state.filterDateTo, true) &&
    isDateFromBeforeDateTo(state.filterDateFrom, state.filterDateTo, true);

  return (
    <section className="slick-page-header-section">
      <Box className="filter-section" display="flex" flexWrap="nowrap" p={0} justifyContent="flex-start" px={1}>
        <Box p={1}>
          <FilterListIcon />
        </Box>
        <Box p={1} width={100} textAlign="end">
          <span>{locale.getMsg('dateFrom')}</span>
        </Box>
        <KeyboardDateSelector
          id="date-picker-inline-to"
          value={state.filterDateFrom}
          onChange={date => setState({ ...state, filterDateFrom: date })}
          maxDate={state.filterDateTo || undefined}
          maxDateMessage=""
          className="calendar-picker-input"
          disableToolbar
        />
        <Box p={1}>
          <span>Date To</span>
        </Box>
        <KeyboardDateSelector
          id="date-picker-inline-to"
          value={state.filterDateTo}
          onChange={date => setState({ ...state, filterDateTo: date })}
          minDate={state.filterDateFrom || undefined}
          minDateMessage={locale.getMsg('dateToBeforeDateFrom')}
          className="calendar-picker-input"
          disableToolbar
        />
        <Box p={1} textAlign="end">
          <span>{locale.getMsg('pasKey')}</span>
        </Box>
        <Box p={1} flexGrow={1}>
          <TextField
            name="pasKey"
            value={state.pasKey}
            fullWidth
            onChange={e => setState({ ...state, pasKey: e.target.value })}
            error={state.pasKeyErrorMessage !== null}
            helperText={state.pasKeyErrorMessage}
            inputProps={{
              maxLength: numberOfChars,
            }}
          />
        </Box>
        <Box p={1} width={100} textAlign="end">
          <span>Event type</span>
        </Box>
        <Box p={1} width={300} flexGrow={1}>
          <Select
            multiple
            onChange={e => setState({ ...state, selectedEventTypes: e.target.value })}
            value={state.selectedEventTypes}
          >
            {eventTypeOptions &&
              eventTypeOptions.map(type => (
                <MenuItem key={type.id} value={type.id}>
                  {generateDescription(type.name)}
                </MenuItem>
              ))}
          </Select>
        </Box>
        <Box p={1} width={50} />
        <Box p={1}>
          <Link className="cancel-link" onClick={handleClear}>
            Clear
          </Link>
        </Box>
        <Box p={1}>
          {isTableDataLoading ? (
            <IconButton size="small" className="search-icon">
              <CircularProgress size={18} color="inherit" />
            </IconButton>
          ) : (
            <IconButton
              size="small"
              className="search-icon"
              onClick={handlePasKeyChange}
              type="submit"
              disabled={!areDatesValid}
            >
              <SearchIcon />
            </IconButton>
          )}
        </Box>
      </Box>
    </section>
  );
}
